export const SITE = {
  brand: "Top End Wheels",
  whatsapp: "61472577752",
  phone: "+61 472 577 752",
  contact_email: "admin@topendwheels.com",
  formspree_id: process.env.REACT_APP_FORMSPREE_ID || "",
  google_business_url: "https://g.page/r/CSVAM7fb8DtjEBM/review",
};

// Flip `enabled` to false to hide the homepage banner.
export const BANNER = {
  enabled: true,
  text: "Dry season (May–Sep) books out early — lock in your Hilux or Kluger dates now.",
  cta: "Check dates",
  href: "/enquiry",
};

// Update these after each new Google review. Set rating to 0 to hide the tile.
export const GOOGLE_REVIEWS = {
  rating: 5.0,
  count: 0,
};

export const VEHICLES = {
  hilux: {
    code: "hilux",
    name: "Toyota Hilux SR 4x4",
    tagline: "Territory-ready tourer",
    path: "adventure",
    seats: 5,
    min_days: 3,
    min_age: 25,
    bond_standard: 5000,
    bond_reduced: 500,
    excess_reduction_per_day: 65,
    daily_rate: 299,
    inclusions: [
      "Full-size spare + recovery kit",
      "Roof rack + tie-downs",
      "12V dual-battery + fridge socket",
      "250 km/day — Unlimited for 5+ day hires",
      "24/7 Darwin roadside",
      "Basic insurance (see excess)",
    ],
    restrictions: [
      "Darwin region + Litchfield + Kakadu sealed sections only",
      "No Cape York, no Gibb River Road",
      "Light off-road on graded tracks only — no water crossings above door sill",
      "GPS-tracked — geographic breach voids bond",
    ],
    gallery: Array.from({ length: 10 }, (_, i) => `/vehicles/hilux/${i + 1}.jpg`),
  },
  kluger: {
    code: "kluger",
    name: "Toyota Kluger Hybrid Grande",
    tagline: "Premium 7-seater family & corporate",
    path: "premium",
    seats: 7,
    min_days: 2,
    min_age: 21,
    bond_standard: 3000,
    bond_reduced: 500,
    excess_reduction_per_day: 35,
    daily_rate: 199,
    inclusions: [
      "7 leather seats + climate zones",
      "Hybrid — sub 6L/100km",
      "Apple CarPlay / Android Auto",
      "Child seat anchors x3",
      "250 km/day — Unlimited for 5+ day hires",
      "Standard comprehensive insurance",
    ],
    restrictions: [
      "Sealed roads only",
      "No off-road, no beach driving",
      "No interstate without written approval",
    ],
    gallery: Array.from({ length: 10 }, (_, i) => `/vehicles/kluger/${i + 1}.jpg`),
  },
};
